<template>
  <badge :type="badgeType" class="status-badge">
    <slot>
      {{status}}
    </slot>
  </badge>
</template>
<script>
  import Badge from './Badge';
  export default {
    name: 'status-badge',
    components: {
      Badge
    },
    props: {
      status: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        successStates: ['active', 'paid', 'sent', 'notice', 'success', 'new', 'yes', 'enabled'],
        dangerStates: ['blocked', 'inactive', 'emergency', 'critical', 'error', 'rejected', 'no', 'disabled'],
        warningStates: ['warning'],
      }
    },
    computed: {
      badgeType () {
        if (this.successStates.includes(this.status)) {
          return 'success'
        }
        if (this.dangerStates.includes(this.status)) {
          return 'danger'
        }
        if (this.warningStates.includes(this.status)) {
          return 'warning'
        }
        return 'info'
      }
    }
  }
</script>
<style scoped>
  .status-badge {
    min-width: 55px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 24px;
  }
</style>
